var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Toggle from 'react-toggle';
export var FilterToggleSelect = function (_a) {
    var item = _a.item, showOnItem = _a.showOnItem, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, tooltip = _a.tooltip, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: showOnItem && !activeFilters[showOnItem] ? null : (_jsxs("label", __assign({ className: "react-toggle-wrapper margin10T", title: tooltip }, { children: [_jsx(Toggle, { checked: activeFilters[item], onChange: function (e) {
                        var _a;
                        var _b;
                        return setFilter((_a = {}, _a[item] = (_b = e.target.checked) !== null && _b !== void 0 ? _b : undefined, _a));
                    } }), _jsx("span", __assign({ className: "label-text" }, { children: label }))] }))),
    });
};
